<template>
  <blockquote class="quote-block" :class="{ 'quote-block--compact': compact }">
    <p v-if="eyebrow" class="quote-block__eyebrow">{{ eyebrow }}</p>
    <p class="quote-block__quote">“{{ quote }}”</p>
    <cite v-if="attribution">
      {{ attribution }}
      <span v-if="role" class="quote-block__role">{{ role }}</span>
    </cite>
  </blockquote>
</template>

<script>
export default {
  name: 'QuoteBlock',
  props: {
    quote: { type: String, required: true },
    attribution: { type: String, default: '' },
    // Second attribution line, for when the speaker's relationship to us is the
    // point: "HRCentral Limited" / "IMPROVE Partner".
    role: { type: String, default: '' },
    // Small label above the quote. Used to mark a partner testimonial so it is
    // not read as a customer one.
    eyebrow: { type: String, default: '' },
    // Supporting quote next to a main one: same card, quieter type.
    compact: { type: Boolean, default: false },
  },
};
</script>

<style scoped>
.quote-block {
  max-width: 680px;
  margin: 32px auto;
  text-align: center;
  background: #fff;
  border: 1px solid #e6ebf1;
  border-radius: 12px;
  padding: 24px 28px;
  box-shadow: 0 8px 24px rgba(0, 36, 88, 0.06);
}

.quote-block__eyebrow {
  margin: 0 0 10px;
  font-size: 11px;
  font-weight: 700;
  letter-spacing: 0.14em;
  text-transform: uppercase;
  color: var(--brand-teal, #08a0a8);
}

.quote-block__quote {
  font-size: 20px;
  color: var(--brand-navy, #002458);
  font-weight: 600;
  margin: 0 0 10px;
  line-height: 1.4;
}

.quote-block cite {
  font-style: normal;
  color: var(--brand-grey, #6b7280);
  font-weight: 600;
  font-size: 14px;
}

.quote-block__role {
  display: block;
  margin-top: 2px;
  font-weight: 600;
  color: var(--brand-teal, #08a0a8);
}

.quote-block--compact .quote-block__quote {
  font-size: 17px;
}

/* Inside a quote-row the row owns the spacing, so the card must not add its own
   auto margins or it breaks the grid alignment. */
.quote-row .quote-block {
  margin: 0;
  max-width: none;
  height: 100%;
}
</style>
